import React from 'react';

import { OptionalAuthProvider } from 'contexts/AuthContext';

import { UserSession, getUserSession } from 'stores/AuthenticationStoreAdapter';
import { UserResult, getUser } from 'stores/UserStoreAdapter';

/**
 * オプショナル認証レイアウトルート。
 * - getUserSession でセッションを試行するが、未ログインでもリダイレクトしない（ゲスト閲覧を許容）。
 * - ログイン済みなら userSession と users を取得してコンテキストに載せる。
 * - ゲスト時は userSession=null / users=[] で描画する。
 *
 * DevInsights（記事一覧・詳細）のようにゲストでも閲覧できる画面のレイアウトに使う。
 */
type Props = {
  layout: React.FC;
};

const OptionalAuthLayoutRoute: React.FC<Props> = ({ layout: Layout }) => {
  const [userSession, setUserSession] = React.useState<UserSession | null>(null);
  const [users, setUsers] = React.useState<UserResult[]>([]);
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    getUserSession()
      .then((session) => {
        if (session) {
          setUserSession(session);
          // ログイン済みのみユーザー一覧を取得（著者選択などに使用）。失敗しても閲覧は続行。
          return getUser({})
            .then((userList) => setUsers(userList))
            .catch(() => setUsers([]));
        }
        return undefined;
      })
      .catch(() => {
        // セッション取得に失敗してもゲストとして続行する
        setUserSession(null);
      })
      .finally(() => setChecked(true));
  }, []);

  if (!checked) {
    return <></>;
  }

  return (
    <OptionalAuthProvider value={{ userSession, users }}>
      <Layout />
    </OptionalAuthProvider>
  );
};

export default OptionalAuthLayoutRoute;
